import { authRoles } from 'app/auth';
import Register from './Register';
import CampaignAuth from './CampaignAuth';

export const RegisterConfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false
				},
				toolbar: {
					display: false
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	},
	auth: authRoles.onlyGuest,
	routes: [
		{
			path: '/register/:slug',
			component: CampaignAuth
		},
		{
			path: '/register',
			component: Register
		}
	]
};
